import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../utils";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: ["Cars", "Car"],
  endpoints: (builder) => ({
    getCars: builder.query({
      query: () => `vehicle/vehicles/`,
      providesTags: ["Cars"],
    }),
    // getCarDetails: builder.query({
    //   query: (id) => `vehicle/vehicles/${id}/`,
    //   providesTags: ["Car"],
    // }),
    getBrandList: builder.query({
      query: () => `vehicle/brands/`,
    }),
    getModelsList: builder.query({
      query: () => `vehicle/models/`,
    }),
    getVehicleTypesList: builder.query({
      query: () => `vehicle/parent_types/`,
    }),
    // getVehiclesByCategory: builder.query({
    //   query: (id) => `vehicle/type/${id}/`,
    //   providesTags: ["Cars"],
    // }),

    // getVehiclesBySubcategory: builder.query({
    //   query: (categoryId, subcategoryId) =>
    //     `vehicle/type/${categoryId}/subtype/${subcategoryId}/`,
    //   providesTags: ["Cars"],
    // }),
  }),
});

// export const fetchVehiclesByCategory = createAsyncThunk(
//   "main/fetchVehiclesByCategory",
//   async (id) => {
//     const response = await apiSlice.endpoints
//       .getVehiclesByCategory(id)
//       .unwrap();
//     return response.data;
//   }
// );

// export const fetchVehiclesBySubcategory = createAsyncThunk(
//   "main/fetchVehiclesBySubcategory",
//   async (categoryId, subcategoryId) => {
//     const response = await apiSlice.endpoints
//       .getVehiclesBySubcategory(categoryId, subcategoryId)
//       .unwrap();
//     return response.data;
//   }
// );

export const {
  useGetCarsQuery,
  useGetCarDetailsQuery,
  useGetBrandListQuery,
  useGetModelsListQuery,
  useGetVehicleTypesListQuery,
  // useGetVehiclesByCategoryQuery,
  // useGetVehiclesBySubcategoryQuery,
} = apiSlice;
